module.exports = __webpack_public_path__ + "5580e772a88eb34bce8dee1a741a4299.svg";